module.exports = __webpack_public_path__ + "fonts/fontello.9d6cb2f.ttf";